import moment from "moment";

/**
 * Formats a given value as a US currency string.
 *
 * @param {any} value - The value to format as currency.
 * @returns {string} The formatted currency string.
 */
export function currency(value: any): string {
  return parseFloat(value).toLocaleString("en-US", { style: "currency", currency: "USD" });
}

/**
 * Formats a given date string into a short date format (MM/DD/YYYY).
 *
 * @param {string} value - The date string to format.
 * @returns {string} The formatted short date string, or an empty string if the value is falsy.
 */
export function shortDate(value: string): string {
  return value ? moment(value).format("MM/DD/YYYY") : "";
}

/**
 * Formats a given date string into a medium date format (e.g., "Sep 12, 2023").
 *
 * @param {string} value - The date string to format.
 * @returns {string} The formatted medium date string, or an empty string if the value is falsy.
 */
export function mediumDate(value: string): string {
  return value ? moment(value).format("MMM D, YYYY") : "";
}

/**
 * Formats a given date string into a full date format
 * (e.g., "Monday, September 12th, 2023").
 *
 * @param {string} value - The date string to format.
 * @returns {string} The formatted full date string, or an empty string if the value is falsy.
 */
export function fullDate(value: string): string {
  return value ? moment(value).format("dddd, MMMM Do, YYYY") : "";
}

/**
 * Formats a given date string into a simple time format (e.g., "3:45 PM").
 *
 * @param {string} value - The date string to format.
 * @returns {string} The formatted time string.
 */
export function simpleTime(value: string): string {
  return moment(value).format("h:mm A");
}

/**
 * Redirects the user to the base URL of the current website.
 *
 * This function extracts the base URL from the current window location
 * by splitting the URL at the `/property/` segment and redirects the
 * browser to the base URL.
 */
export function redirectToBaseUrl() {
  const currentUrl = window.location.href;
  const baseUrl = currentUrl.split('/property/')[0];
  window.location.href = baseUrl;
}
